export const telparkDocValidations = {
  telpark_totalamount_mismatch_amountincvat: `El importe total '{{0}}' no coincide con la suma de los importes (IVA incluido) '{{1}}' de la tabla de gastos.`,
};
